import React from 'react';
import { ProfileStep3 } from './profileStep3';
import { connect } from 'react-redux';
import { showModalCancel } from 'actions/modalCancelActions';
import { changeCurrentStep, enableFinishedAndNextStep, finalizeStep } from 'actions/stepsActions';
import { clientDefiniteKO, callCenterKO } from 'actions/identityValidationActions';
import { actions } from 'react-redux-form';
import { getServerDate, setServerDate } from 'actions/optionsActions';
import { hidePreLoader } from 'actions/preLoaderActions';
import { identifyIban, identifyTransfer } from 'actions/identify';
import { startPolling, stopPolling } from 'actions/polling';
import { resetIban, resetIdentityIban, setIbanError } from 'actions/ibanActions';
import { identifyVideo } from 'actions/identify';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import withIdentifyMethodParser from 'hocs/withIdentifyMethodParser';
import { goToErrorsView } from 'actions/errorViewNavigation';

const { change, setValidity, resetValidity } = actions;

const ProfileStep3Container = props => {
    return <ProfileStep3 {...props} />;
};

export default connect(
    state => ({
        polling: state.polling,
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
        iban: state.iban,
        immStepsState: state.steps,
        video: state.video,
        videoAvailability: state.videoAvailability,
    }),
    {
        showModalCancel,
        enableFinishedAndNextStep,
        clientDefiniteKO,
        callCenterKO,
        finalizeStep,
        change,
        setValidity,
        resetValidity,
        changeCurrentStep,
        getServerDate,
        hidePreLoader,
        identifyIban,
        identifyTransfer,
        setServerDate,
        startPolling,
        stopPolling,
        resetIban,
        identifyVideo,
        resetIdentityIban,
        setIbanError,
        goToErrorsView,
    }
)(withIdentifyMethodParser(withFeatureToggling(ProfileStep3Container)));
